export const CONSTANTS = {
  LIST_SAVED_VIEWS: 'list-grid-saved-views',
  REQUEST_LOAD_VIEW: 'request-grid-load-view',
  REQUEST_SAVE_VIEW: 'request-grid-save-view',
  REQUEST_SAVE_CONFLICT_CHECK: 'request-grid-save-conflict-check',
  REQUEST_REMOVE_VIEW: 'request-grid-remove-view',
  FILE_UPLOAD: 'request-file-upload',
  FILE_DOWNLOAD: 'request-file-download',
  OKAY: 'OKAY',
  COMPLETE: 'COMPLETE',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  CONFIRM: 'CONFIRM',
  EXCEPTION: 'EXCEPTION',
} as const;
